import {
    List,
    Datagrid,
    TextField,
    ReferenceField,
    Filter,
    TextInput,
    EditButton,
    ShowButton,
    DeleteButton, ReferenceInput, AutocompleteInput
} from 'react-admin'

const SuggestionFeedbackConfigsFilter = props => (
  <Filter {...props}>
    <TextInput source="id" />
    <TextInput source="name" />
      <ReferenceInput
          source="client.id"
          reference="clients"
          label="Cliente"
          sort={{ field: 'name', order: 'ASC' }}
          perPage={1000}
      >
          <AutocompleteInput source="name" optionText="name" filterToQuery={(searchText) => ({ name: searchText })}/>
      </ReferenceInput>
    <TextInput source="remote_name" />
  </Filter>
)

const SuggestionFeedbackConfigsList = () => (
  <List exporter={false} filters={<SuggestionFeedbackConfigsFilter />}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="remote_name" />
      <ReferenceField source="client.id" reference="clients" allowEmpty>
        <TextField source="name" />
      </ReferenceField>
        <EditButton />
        <ShowButton />
        <DeleteButton />
    </Datagrid>
  </List>
)

export default SuggestionFeedbackConfigsList
